module.exports = __webpack_public_path__ + "img/crypto5.680f3f4f.png";